import { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useFormik } from "formik";
import * as Yup from "yup";
import UserAddressService from "../../services/useraddress/useraddress.service";
import { error } from "console";
 
const AddingNewCountry = () => {
  const [visible, setVisible] = useState(false);
  const toast = useRef<Toast>(null);
 
  const formik = useFormik({
    initialValues: {
      countryName: "",
      countryCode: "",
      stateName: "",
      districtName: "",
      subDistrictName: "",
    },
    validationSchema: Yup.object({
      countryName: Yup.string().required("Country name is required"),
      countryCode: Yup.string().required("Country code is required"),
      stateName: Yup.string().required("State name is required"),
      districtName: Yup.string().required("District name is required"),
      subDistrictName: Yup.string().required("Sub-district name is required"),
    }),
    onSubmit: async (data) => {
      try {
        const countryRes = await UserAddressService.addNewCountry({
          countryName: data.countryName,
          countryCode: data.countryCode,
        });
        
        const countryId = countryRes.isSuccess ? countryRes.id : 0;
        if (!countryId || countryId === 0) throw new Error("Invalid countryId");
 
        const stateRes = await UserAddressService.addNewState({
          stateName: data.stateName,
          countryId: countryId,
        });
 
        const stateId = stateRes.isSuccess ? stateRes.id : 0;
        if(!stateId || stateId === 0) throw new Error("Invalid stateId");
 
        const districtRes = await UserAddressService.addNewDistrict({
          districtName: data.districtName,
          stateId: stateId,
        });
 
        const districtId = districtRes.isSuccess ? districtRes.id : 0;
        if(!districtId || districtId === 0) throw new Error("Invalid districtId");
 
        const subDistrictRes = await UserAddressService.addNewSubDistrict({
          subDistrictName: data.subDistrictName,
          districtId: districtId,
        });
 
        const subdistrictId = subDistrictRes.isSuccess ? subDistrictRes.id : 0;
        if(!subdistrictId || subdistrictId === 0) throw new Error("Invalid subdistrictId");
 
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Location hierarchy added",
        });
 
        setVisible(false);
        formik.resetForm();
      } catch (error: any) {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.message || "Failed to add entries",
        });
      }
    },
  });
 
  return (
    <>
      <Toast ref={toast} />
 
      <Button
        icon="pi pi-plus"
        label="Add Country"
        className="p-button-success mb-2"
        onClick={() => setVisible(true)}
      />
 
      <Dialog
        header="Add Country Details"
        visible={visible}
        style={{ width: "60vw" }}
        onHide={() => setVisible(false)}
        modal
        footer={
          <div className="flex justify-content-end gap-2">
            <Button label="Cancel" icon="pi pi-times" onClick={() => setVisible(false)} />
            <Button label="Save" icon="pi pi-check" onClick={() => formik.handleSubmit()} />
          </div>
        }
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid grid">
          <div className="field col-6">
            <label>Country Name *</label>
            <InputText
              name="countryName"
              value={formik.values.countryName}
              onChange={formik.handleChange}
              className={formik.errors.countryName && formik.touched.countryName ? "p-invalid" : ""}
            />
            {formik.errors.countryName && formik.touched.countryName && (
              <small className="p-error">{formik.errors.countryName}</small>
            )}
          </div>
 
          <div className="field col-6">
            <label>Country Code *</label>
            <InputText
              name="countryCode"
              value={formik.values.countryCode}
              onChange={formik.handleChange}
              className={formik.errors.countryCode && formik.touched.countryCode ? "p-invalid" : ""}
            />
            {formik.errors.countryCode && formik.touched.countryCode && (
              <small className="p-error">{formik.errors.countryCode}</small>
            )}
          </div>
 
          <div className="field col-6">
            <label>State Name *</label>
            <InputText
              name="stateName"
              value={formik.values.stateName}
              onChange={formik.handleChange}
              className={formik.errors.stateName && formik.touched.stateName ? "p-invalid" : ""}
            />
            {formik.errors.stateName && formik.touched.stateName && (
              <small className="p-error">{formik.errors.stateName}</small>
            )}
          </div>
 
          <div className="field col-6">
            <label>District Name *</label>
            <InputText
              name="districtName"
              value={formik.values.districtName}
              onChange={formik.handleChange}
              className={formik.errors.districtName && formik.touched.districtName ? "p-invalid" : ""}
            />
            {formik.errors.districtName && formik.touched.districtName && (
              <small className="p-error">{formik.errors.districtName}</small>
            )}
          </div>
 
          <div className="field col-6">
            <label>Sub-District Name *</label>
            <InputText
              name="subDistrictName"
              value={formik.values.subDistrictName}
              onChange={formik.handleChange}
              className={formik.errors.subDistrictName && formik.touched.subDistrictName ? "p-invalid" : ""}
            />
            {formik.errors.subDistrictName && formik.touched.subDistrictName && (
              <small className="p-error">{formik.errors.subDistrictName}</small>
            )}
          </div>
        </form>
      </Dialog>
    </>
  );
};
 
export default AddingNewCountry;
 
 